import iApi from '../_api.js';

const iIntake = {
    mixins: [iApi],

    methods: {
        getIntake(token, complete_fn) {
            let $this = this;
            let intake = null;

            if (token) {
                jQuery.when(
                    this.callApi('GET', '/intakes/permalink/' + token, null, function (result) {
                        intake = result;       
                    }),
                ).then(function () {
                    return complete_fn(intake);
                });
            }
        },
    }
};

export default iIntake;
